import { motion } from "framer-motion";
import { INDUSTRIES } from "@/lib/site-data";
import { Building2 } from "lucide-react";

export default function Industries() {
  return (
    <section data-testid="industries-section" id="industries" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Industries</div>
            <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
              Trusted across <span className="gold-gradient-text font-medium">the value chain</span>.
            </h2>
            <p className="mt-5 text-[#4B5563] text-base leading-relaxed">
              From jewellers and bullion dealers to banks and industrial recyclers — Agroya partners with every link
              in India's precious-metals ecosystem.
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-3">
            {INDUSTRIES.map((it, i) => (
              <motion.div
                key={it}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.04 }}
                data-testid={`industry-${i}`}
                className="flex items-center gap-3 p-4 border border-[#E5E5E5] rounded-md hover:border-[#D4AF37] hover:bg-[#F4F9FC] transition-all"
              >
                <Building2 className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.5} />
                <span className="text-sm text-[#0A0A0A] font-medium">{it}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
